import Button from "devextreme-react/button";
import React, {useContext, useEffect, useState} from "react";
import {EstimateContext, RefetchScope} from "../context/EstimateContext";
import {Popup, ToolbarItem} from 'devextreme-react/popup';
import {TextBox} from "devextreme-react/text-box";
import {RequiredRule, Validator} from "devextreme-react/validator";
import {ValidationSummary} from "devextreme-react/validation-summary";
import {useConfirmOrder} from "../api/confirm-order";
import {showErrorMessage, showSuccessMessage} from "../../../../utils/messages";
import {queryClient} from "../../../../lib/react-query";
import {NumberBox} from "devextreme-react/number-box";
import FileAttachmentUploader from "../../../common/file-attachments/components/FileAttachmentUploader";
import {FileTypes, KindOfOrder} from "../../../../types/enums";
import FileAttachmentGrid from "../../../common/file-attachments/components/FileAttachmentGrid";

export default function ConfirmOrderButton() {
    const {order, refetchOrder} = useContext(EstimateContext);
    const [isPopupVisible, setIsPopupVisible] = useState<boolean>(false);
    const [roNumber, setRONumber] = useState<string>('');
    const [roAmount, setROAmount] = useState<number>(0);
    const confirmOrder = useConfirmOrder(order.details.quoteID, roNumber, roAmount);

    const getCloseButtonOptions = {
        stylingMode: 'contained',
        text: 'Close',
        type: 'normal',
        onClick: () => setIsPopupVisible(false)
    };

    useEffect(() => {
        setROAmount(order.details.confirmOrderSettings.amount);
    }, [order.details.confirmOrderSettings.amount]);

    return (
        <>
            <Popup
                visible={isPopupVisible}
                showTitle={true}
                width={800}
                height={600}
                title={"Submit RO Information"}
                shading={true}
                showCloseButton={true}
                onHidden={() => {
                    setIsPopupVisible(false);
                }}
                position={'center'}
            > <ToolbarItem
                widget="dxButton"
                toolbar="bottom"
                location="after"
                disabled={confirmOrder.isLoading}
                options={{
                    stylingMode: 'contained',
                    text: 'OK',
                    validationGroup: 'confirmOrder',
                    onClick: async (e: any) => {
                        if (!e.validationGroup.validate().isValid) {
                            return;
                        }
                        let result = await confirmOrder.mutateAsync();
                        if (result.isSuccess) {
                            showSuccessMessage("Retail Order has been created successfully");
                            setIsPopupVisible(false);
                            await queryClient.invalidateQueries({queryKey: ['dealer-estimate', order.details.quoteID]});
                        } else
                            showErrorMessage(result.errorMessage!);
                    },
                }}
            />
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={getCloseButtonOptions}
                />
                <div>
                    <div className="dx-field">
                        <TextBox
                            mode={'text'}
                            value={roNumber}
                            width={'200'}
                            label='RO Number'
                            labelMode={'outside'}
                            onValueChanged={(e) => {
                                setRONumber(e.value);
                            }
                            }
                        >
                            <Validator validationGroup="confirmOrder">
                                <RequiredRule message={'RO number is required'}/>
                            </Validator>
                        </TextBox>
                    </div>
                    <div className="dx-field">
                        <NumberBox
                            mode={'number'}
                            value={roAmount}
                            width={'200'}
                            label='RO Amount'
                            showSpinButtons={true}
                            format="$#0.00"
                            min={0}
                            labelMode={'outside'}
                            onValueChanged={(e) => {
                                setROAmount(e.value);
                            }
                            }
                        >
                            <Validator validationGroup="confirmOrder">
                                <RequiredRule message={'RO Amount is required'}/>
                            </Validator>
                        </NumberBox>
                    </div>
                    <div className="dx-fieldset">
                        <div className="dx-field">
                            <span>Upload RO File</span>
                        </div>
                        <FileAttachmentGrid
                            visible={true}
                            kindOfOrder={KindOfOrder.EstimatePOUpload}
                            parentGuid={order.details.guid}
                            orderID={undefined}
                            useFileTypes={false}
                            fileTypeFilter={(e) => e === FileTypes.UploadPO}
                            defaultFileType={FileTypes.UploadPO}
                            onFileAdded={async () => {
                                await refetchOrder(RefetchScope.Files);
                            }}
                            onFileDeleted={async () => {
                                await refetchOrder(RefetchScope.Files);
                            }}
                            attachedFiles={order.details.confirmOrderSettings.files}
                        />
                    </div>
                </div>
                <ValidationSummary validationGroup='confirmOrder'></ValidationSummary>
            </Popup>
            <Button
                text="Confirm"
                icon="Inscyth-Confirm"
                visible={order.details.confirmOrderSettings.isVisible}
                disabled={!order.details.confirmOrderSettings.isEnabled}
                onClick={() => {
                    setRONumber('');
                    setROAmount(order.details.confirmOrderSettings.amount);
                    setIsPopupVisible(true);
                }}>
            </Button>
        </>
    )
}
